import { render, staticRenderFns } from "./P04.vue?vue&type=template&id=8f204218&scoped=true"
import script from "./P04.vue?vue&type=script&lang=js"
export * from "./P04.vue?vue&type=script&lang=js"
import style0 from "./P04.vue?vue&type=style&index=0&id=8f204218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f204218",
  null
  
)

export default component.exports